import { Maximize } from 'lucide-react';
import { useEffect, useState } from 'react';

const FullscreenToggle: React.FC = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const enterFullscreen = async () => {
      try {
        if (!document.fullscreenElement) {
          await document.documentElement.requestFullscreen();
        }
      } catch (error) {
      }
    };

    enterFullscreen();
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const toggleFullscreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch (error) {
    }
  };

  if (isFullscreen) {
    return null;
  }

  return (
    <div className="absolute top-4 left-4 z-50">
      <button
        onClick={toggleFullscreen}
        className="p-2 rounded-lg backdrop-blur-sm bg-black/30 hover:bg-black/50 text-white transition-all duration-200 hover:scale-105"
        title="Enter fullscreen"
      >
        <Maximize className="w-5 h-5" />
      </button>
    </div>
  );
};

export default FullscreenToggle;
